import React, { useEffect, useState } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import { getStageConversionReport } from '../../../../Services/CRMAdminServices/CRMDashboardService';
import StageFunnel from './StageFunnel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../ReduxToolkit/Store';
// import DropdownWithValueName from "../../../common/DropdownWithValueName";

// interface NearSaleDeal {
//     leadID: number;
//     firstName: string;
//     surname: string;
//     staff: string;
//     followUp: string;
//     mpp: string;
//     latestComment: string;
//     staffFullName: string;
//     mppValue: string;
// }

// interface Lead {
//     id: number;
//     stage: string;
// }
// interface StaffStageCounts {
//     staffId: number;
//     staffName: string;
//     discoveryUnits: number;
//     financeUnits: number;
//     financePercent: number;
//     propertySearchUnits: number;
//     propertySearchPercent: number;
//     propertyPresentUnits: number;
//     propertyPresentPercent: number;
//     eoiUnits: number;
//     eoiPercent: number;
//     contractUnits: number;
//     contractPercent: number;
//     settlementUnits: number;
//     settlementPercent: number;
// }

interface StageConversionRecord {
    stage: string;
    count: number;
    conversionPercent: string;
    leadPercent: string;
}





const CRMDashboard = () => {


    // const [leadStageCounts, setLeadStageCounts] = useState<any[]>([]);

    // const [nearSaleDeals, setNearSaleDeals] = useState<NearSaleDeal[]>([]);
    // const [stageDropdownOpen, setStageDropdownOpen] = useState(false);
    // const [staffDropdownOpen, setStaffDropdownOpen] = useState(false);

    // const [totalPages, setTotalPages] = useState<number>(1);
    // const [staffList, setStaffList] = useState<any[]>([]);
    // const [stageList, setStageList] = useState<any[]>([]);
    // const [leadsData, setLeadsData] = useState<Lead[]>([]);

    // // 🔹 Frontend page (1-based)
    // const [currentPage, setCurrentPage] = useState<number>(1);

    // // 🔹 API params (without pageNumber, handled separately)
    // const [formData, setFormData] = useState<any>({
    //     source: "",
    //     staff: "",
    //     stage: "",
    //     textMessage: "",
    //     followUp: "",
    //     assignToNewStaff: "",
    //     newstageid: "",
    //     commentText: "",
    //     pageNumber: 0,
    //     pageSize: 10,
    // });

    const [stageReport, setStageReport] = useState<StageConversionRecord[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [loadError, setLoadError] = useState<string | null>(null);

    const [timePeriod, setTimePeriod] = useState<string>('Monthly');
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

    // Calculate date range based on time period
    const getDateRange = (period: string): { fromDate: string; toDate: string } => {
        const today = new Date();
        const toDate = today.toISOString().split('T')[0];
        let fromDate = '';

        switch (period) {
            case 'All':
                fromDate = '2020-01-01'; // Get all data from 2020
                break;
            case 'Daily':
                fromDate = toDate;
                break;
            case 'Weekly':
                const weekAgo = new Date(today);
                weekAgo.setDate(today.getDate() - 7);
                fromDate = weekAgo.toISOString().split('T')[0];
                break;
            case 'Monthly':
                const monthAgo = new Date(today);
                monthAgo.setMonth(today.getMonth() - 1);
                fromDate = monthAgo.toISOString().split('T')[0];
                break;
            case 'YTD (Jan–Dec)':
                fromDate = `${today.getFullYear()}-01-01`;
                break;
            default:
                fromDate = toDate;
        }

        return { fromDate, toDate };
    };

    const { RoleID } = useSelector((state: RootState) => state.adminAuth);
    const isAdmin = Number(RoleID) === 1 || RoleID == null;
    const { fromDate: periodFrom, toDate: periodTo } = getDateRange(timePeriod);

    useEffect(() => {
        if (!isAdmin) {
            return;
        }

        const fetchStageReport = async () => {
            setIsLoading(true);
            setLoadError(null);
            try {
                const response = await getStageConversionReport();
                if (Array.isArray(response?.data)) {
                    setStageReport(response.data as StageConversionRecord[]);
                } else {
                    setStageReport([]);
                }
            } catch (error) {
                console.error("Error fetching stage conversion report:", error);
                setStageReport([]);
                setLoadError("Unable to load stage conversion data right now.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchStageReport();
    }, [isAdmin]);



    // // 🔹 Generic handler
    // const handleValueChange = (name: string, value: string | null) => {
    //     setFormData((prev: any) => ({
    //         ...prev,
    //         [name]: value,
    //     }));
    //     setCurrentPage(1); // ✅ Reset to first page when filter changes
    // };


    // // 🔹 Existing API call for leads (cards + charts)
    // useEffect(() => {
    //     if (isAdmin) {
    //         const fetchData = async () => {
    //             try {
    //                 const leadsResponse = await getLeadStageCounts();
    //                 const leads: Lead[] = leadsResponse.data;
    //                 setLeadsData(leads);
    //             } catch (error) {
    //                 console.error('Error fetching dashboard data:', error);
    //             }
    //         };
    //         fetchData();
    //     }
    // }, [isAdmin]);

    // // 🔹 Fetch staff + stages from DDL API
    // useEffect(() => {
    //     const fetchDDL = async () => {
    //         try {
    //             const response = await getCrmDDLService();
    //             if (response?.data) {
    //                 setStaffList(response.data.staff || []);
    //                 setStageList(response.data.allStages || []);
    //             }
    //         } catch (error) {
    //             console.error("Error fetching DDL:", error);
    //         }
    //     };
    //     fetchDDL();
    // }, []);


    // // 🔹 Fetch near-sale deals
    // // useEffect fetch deals
    // useEffect(() => {
    //     if (isAdmin) {
    //         const fetchDeals = async () => {
    //             try {
    //                 const response = await getNearSaleDeals({
    //                     ...formData,
    //                     pageNumber: currentPage,
    //                     pageSize: formData.pageSize,
    //                 });

    //                 if (Array.isArray(response?.data)) {
    //                     setNearSaleDeals(response.data);

    //                     // ✅ If returned items are less than pageSize → last page
    //                     if (response.data.length < formData.pageSize) {
    //                         setTotalPages(currentPage);
    //                     } else {
    //                         setTotalPages(currentPage + 1); // assume there may be more
    //                     }
    //                 } else {
    //                     setNearSaleDeals([]);
    //                     setTotalPages(1);
    //                 }
    //             } catch (error) {
    //                 console.error("Error fetching near-sale deals:", error);
    //                 setNearSaleDeals([]);
    //             }
    //         };
    //         fetchDeals();
    //     }
    // }, [isAdmin, formData, currentPage]);



    // const toggleStageDropdown = () => setStageDropdownOpen(prev => !prev);
    // const toggleStaffDropdown = () => setStaffDropdownOpen(prev => !prev);

    // const formatDate = (dateString: string) => {
    //     if (!dateString) return "";
    //     const date = new Date(dateString);
    //     return date.toLocaleDateString('en-GB');
    // };


    // //  🔹 Old logic for dashboard cards
    // const calculateStatsFromLeads = () => {
    //     const assignedLeads = leadsData.filter(lead => lead.stage);
    //     const Lead = assignedLeads.filter(lead => lead.stage === 'Lead').length;
    //     const Strategy = assignedLeads.filter(lead => lead.stage === 'Strategy Call').length;
    //     const Gameplan = assignedLeads.filter(lead => lead.stage === 'Gameplan').length;
    //     const DiscoveryCall = assignedLeads.filter(lead => lead.stage === 'Discovery Call').length;
    //     const PropertyPresentation = assignedLeads.filter(lead => lead.stage === 'Prop Present').length;
    //     const PropertySearch = assignedLeads.filter(lead => lead.stage === 'Property Search').length;
    //     const Contracts = assignedLeads.filter(lead => lead.stage === 'Contracts').length;
    //     const Settlements = assignedLeads.filter(lead => lead.stage === 'Settlement').length;
    //     const Review = assignedLeads.filter(lead => lead.stage === "Review").length;
    //     const Finance = assignedLeads.filter(lead => lead.stage === 'Finance').length;
    //     const totalStages = Gameplan + Strategy + Finance + DiscoveryCall + PropertyPresentation + PropertySearch + Contracts + Settlements + Review;

    //     const dashboardCards = [
    //         {
    //             title: <>DISCOVERY</>,
    //             background: '#ff0000',
    //             color: 'white',
    //             items: [
    //                 { label: 'Leads', value: Lead },
    //                 { label: 'Clients', value: totalStages },
    //                 { label: 'Discovery', value: DiscoveryCall },
    //                 { label: 'Finance', value: Finance },
    //             ],
    //         },
    //         {
    //             title: <>PRE PURCHASE</>,
    //             background: '#ffff00',
    //             color: 'black',
    //             items: [
    //                 { label: 'Strategy Call', value: Strategy },
    //                 { label: 'Gameplan', value: Gameplan },
    //                 { label: 'Prop Search', value: PropertySearch },
    //                 { label: 'Prop Presentation', value: PropertyPresentation },
    //             ],
    //         },
    //         {
    //             title: <>PURCHASE</>,
    //             background: '#00b050',
    //             color: 'white',
    //             items: [
    //                 { label: 'Contract', value: Contracts },
    //                 { label: 'Settlement', value: Settlements },
    //                 { label: 'Review', value: Review },
    //             ],
    //         },
    //     ];

    //     return dashboardCards;
    // };

    // const dashboardCards = calculateStatsFromLeads();

    return (
        <Container fluid className="dashboard-container p-2 bg-light">
            {isAdmin ? (
                <>
                    {/* Title + time period (drives both funnels below) */}
                    <Row className="mt-4 justify-content-center">
                        <Col xs={12} md={12} lg={12}>
                            <Card className="shadow-sm border-0 mb-3">
                                <CardBody className="p-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h2 className="fw-bold mb-0" style={{ color: '#0044ff' }}>
                                            Dashboard
                                        </h2>
                                        <div className="d-flex gap-3 align-items-center">
                                            <span className="fw-semibold">Time Period</span>
                                            <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
                                                <DropdownToggle
                                                    caret
                                                    color="light"
                                                    style={{
                                                        minWidth: '180px',
                                                        backgroundColor: 'white',
                                                        color: '#333',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '8px',
                                                        padding: '8px 16px',
                                                        fontWeight: '500',
                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                    }}
                                                >
                                                    {timePeriod}
                                                </DropdownToggle>
                                                <DropdownMenu
                                                    style={{
                                                        borderRadius: '8px',
                                                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                        border: '1px solid #e0e0e0',
                                                        minWidth: '180px',
                                                        padding: '8px 0'
                                                    }}
                                                >
                                                    <DropdownItem onClick={() => setTimePeriod('All')}>
                                                        All {timePeriod === 'All' && '✓'}
                                                    </DropdownItem>
                                                    <DropdownItem onClick={() => setTimePeriod('Daily')}>
                                                        Daily {timePeriod === 'Daily' && '✓'}
                                                    </DropdownItem>
                                                    <DropdownItem onClick={() => setTimePeriod('Weekly')}>
                                                        Weekly {timePeriod === 'Weekly' && '✓'}
                                                    </DropdownItem>
                                                    <DropdownItem onClick={() => setTimePeriod('Monthly')}>
                                                        Monthly {timePeriod === 'Monthly' && '✓'}
                                                    </DropdownItem>
                                                    <DropdownItem onClick={() => setTimePeriod('YTD (Jan–Dec)')}>
                                                        YTD (Jan–Dec) {timePeriod === 'YTD (Jan–Dec)' && '✓'}
                                                    </DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>

                            {/* Stage funnel - every CRM stage, Common / MB / IP */}
                            <StageFunnel fromDate={periodFrom} toDate={periodTo} />

                        </Col>
                    </Row>

                    {/* Legacy dashboard widgets are commented out above and retained for reference. */}
                    {/* <Row className="mt-4 justify-content-center">
                        <Col xs={12} md={12} lg={12}>
                            <Card className="shadow-sm border-0">
                                <CardBody className="p-8">
                                    <div className="text-center mb-4">
                                        <h1 className="fw-bold mb-1" style={{ color: '#0044ff' }}>
                                            Fintrack Dashboard
                                        </h1>
                                    </div>

                                    {loadError && (
                                        <div className="text-center text-danger mb-3">
                                            {loadError}
                                        </div>
                                    )}

                                    {isLoading ? (
                                        <div className="text-center text-muted py-4">
                                            Loading stage conversion report...
                                        </div>
                                    ) : (
                                        <div className="d-flex justify-content-center">
                                            <table
                                                className="table table-borderless w-auto"
                                                style={{ minWidth: '860px' }}
                                            >
                                                <thead>
                                                    <tr style={{ color: '#0044ff', fontWeight: 700, fontSize: '18px' }}>
                                                        <th className="px-4 py-2" style={{ color: '#0044ff' }}>Stage</th>
                                                        <th className="px-4 py-2 text-center" style={{ color: '#0044ff' }}>Count</th>
                                                        <th className="px-4 py-2 text-center" style={{ color: '#0044ff' }}>Conversion % (to next)</th>
                                                        <th className="px-4 py-2 text-center" style={{ color: '#0044ff' }}>Lead %</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {stageReport.length === 0 ? (
                                                        <tr>
                                                            <td colSpan={3} className="text-center text-muted py-3">
                                                                No stage conversion data available.
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        stageReport.map((record, idx) => (
                                                            <tr key={`${record.stage}-${idx}`} className="border-top">
                                                                <td className="px-4 py-3 fw-semibold">{record.stage}</td>
                                                                <td className="px-4 py-3 text-center">{record.count}</td>
                                                                <td className="px-4 py-3 text-center">
                                                                    {record.conversionPercent && record.conversionPercent.trim() !== ""
                                                                        ? record.conversionPercent
                                                                        : '-'}
                                                                </td>
                                                                <td className="px-4 py-3 text-center">
                                                                    {record.leadPercent && record.leadPercent.trim() !== ""
                                                                        ? record.leadPercent
                                                                        : '-'}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row> */}
                </>
            ) : (
                <p className="text-center text-muted">You don't have permission to view this dashboard.</p>
            )}
        </Container>
    );
};

export default CRMDashboard;



